import React from "react";
import GridComponent from "../components/Grid";

const title = "キャラクター紹介";
const data = [
  { id: 1, image: "kirikan.jpg", title: "キリ看ちゃん", description: "本名ジャンヌ・カルバン。語学堪能で聖書の言語はすべて取得済み。ASMRキリスト教会の主任牧師である。若干武闘派で、いつも信徒をメルカリに出品したりぶっとばしたりしている。" },
  { id: 2, image: "jiaozi.jpg", title: "ギョーザちゃん", description: "普段はコンビニでバイトしているクリスチャンの中国人JK。東大志望の40歳に追いかけ回されている。" },
  { id: 3, image: "junpei.jpg", title: "浜崎順平", description: "キリ看ちゃんのいきつけのファミレスで働くアルバイト。なぜかルックスがドンピシャでキリ看ちゃんに惚れられている。" },
  { id: 4, image: "mahjong.jpg", title: "麻雀中年", description: "礼拝のときにいつも麻雀をしている不真面目な信徒。礼拝中に喫煙もしてしまう" },
  { id: 5, image: "ronin.jpg", title: "多浪田吾作", description: "40歳になっても東大を夢見てひたすら浪人生活を続ける東大志望。ギョーザちゃんに一目惚れし、ストーカー行為を繰り返していたが、キリ看ちゃんに制裁を受け、聖書を全ページ読まないと出られない部屋でお仕置きを受けたが、改心はしていない。" },
  { id: 6, image: "satan.jpg", title: "サタンちゃん", description: "サタンを具現化したJK。キリ看ちゃんの伝道を妨害したり教会を無茶苦茶にすることを生き甲斐としている。" },
  { id: 7, image: "zenra.jpg", title: "服梨龍之介", description: "つねに全裸で生活する異常者。素性はまだ明かされていないが若干鳥山先生を意識した画風をしている" },
  { id: 8, image: "cheese.jpg", title: "牛村千鶴男", description: "チーズ牛丼を具現化した男。弱者男性の典型でありこれといった特技はない童貞である。救いようがない" },
  { id: 9, image: "gahaku.jpg", title: "生藤すう(いくとおすう)", description: "ASMRキリスト教会専属漫画家が輪廻転生した姿。明らかにキリスト教の設定から逸脱している。前世の40代男性の性格の悪さや口の悪さ、キレやすさみたいな負の遺産を受け継いでおり、メンヘラ度が高い。" },
  { id: 10, image: "", title: "", description: "" },
];

const Character = () => {
  return (
    <div>
      <GridComponent data={data} title={title} dir="characters" />
    </div>
  );
};

export default Character;
